import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

type ForgotPasswordForm = {
  email: string;
};

export const forgotPasswordReset = ({
  email,
}: ForgotPasswordForm): Promise<void> => {
  return axios.post('/api/auth/forgot-password', { email });
};

export const useForgotPasswordMutation = () => {
  return useMutation({
    mutationFn: ({ email }: ForgotPasswordForm) =>
      forgotPasswordReset({ email }),
  });
};
